import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { isEmpty } from 'lodash-es';
import { connect } from 'react-redux';

import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';

import { connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { bindToContent, CmsEntities } from 'client/data/models/cms';
import { DEFAULT_CONTENT } from 'client/data/cms/content';
import { RESEARCH_LINK_WIDGET_EDITORIAL_PATH } from 'site-modules/shared/constants/editorial/research-article';

import { getImageUrl, SOURCES } from 'client/utils/image-helpers';
import { AdUnit } from 'site-modules/shared/components/ad-unit/ad-unit';
import { ContentFragment } from 'site-modules/shared/components/content-fragment/content-fragment';
import { CREATIVE_ID } from 'site-modules/shared/components/upper-funnel/vehicle-showcase/constants';

import './vehicle-showcase-cards.scss';

function VehicleShowcaseUI({ content = DEFAULT_CONTENT, isMobile = false, adName = 'hpshow', className = null }) {
  const slides = content?.children();

  if (isEmpty(slides)) {
    return null;
  }

  return (
    <div
      className={classnames('vehicle-showcase-cards pos-r overflow-hidden', className)}
      data-tracking-parent={CREATIVE_ID}
    >
      <div id="vehicle-showcase-list" className="heading-3 mb-1_5">
        Consider these recommendations<sup className="small fw-medium text-cool-gray-50 ms-0_25">Ad</sup>
      </div>
      <Row tag="ul" aria-labelledby="vehicle-showcase-list" className="list-unstyled">
        {slides.map((slideItem, index) => {
          const { thumbTitle, thumbImage, ctaUrlMobile, ctaUrl, ctaText, ctaTargetNew, copyText } =
            slideItem.getAllMetadata();
          const vehicleImage = getImageUrl(thumbImage, null, SOURCES.STATIC);
          const finalUrl = isMobile ? ctaUrlMobile : ctaUrl;
          const targetNew = ctaTargetNew === 'true';
          const position = index + 1;

          return (
            <Col tag="li" xs={12} md={6} key={slideItem.id} className="mb-1">
              <a
                className="vs-card text-blue-50 text-decoration-none"
                href={encodeURI(finalUrl)}
                rel={'nofollow noreferrer'}
                data-tracking-id={targetNew ? 'vehicle_showcase_click_out' : 'vehicle_showcase_click_in'}
                data-tracking-value={`main_${ctaText}`}
                data-tracking-position={position}
                target={targetNew ? '_blank' : '_self'}
              >
                <Row>
                  <Col xs={3}>
                    <img src={vehicleImage} alt="" loading="lazy" className="w-100 rounded" />
                  </Col>
                  <Col xs={9}>
                    <ContentFragment classes="fw-bold text-gray-darkest mb-0_25">{thumbTitle}</ContentFragment>
                    {!!copyText && <ContentFragment classes="text-gray-darkest mb-0_25">{copyText}</ContentFragment>}
                    <div className="cta-text">
                      <span className="fw-medium">{ctaText}</span>
                      {targetNew && <i className="icon-open_in_new ms-0_25 medium" aria-hidden />}
                    </div>
                  </Col>
                </Row>
              </a>
            </Col>
          );
        })}
      </Row>

      {slides.map((slide, index) => {
        const adProps = {
          key: slide.id,
          position: `${index + 1}`,
          oneByOne: true,
          renderWhenViewable: false,
          ...(isMobile
            ? {
                adName: `m${adName}`,
                xs: true,
                sm: true,
              }
            : {
                adName,
                md: true,
                lg: true,
                xl: true,
              }),
        };
        return <AdUnit {...adProps} />;
      })}
    </div>
  );
}

VehicleShowcaseUI.propTypes = {
  content: CmsEntities.Content,
  isMobile: PropTypes.bool,
  adName: PropTypes.string,
  className: PropTypes.string,
};

const mapStateToProps = state => ({
  isMobile: state.mobile,
});

export const VehicleShowcaseCards = connect(mapStateToProps)(
  connectToModel(VehicleShowcaseUI, {
    content: bindToContent(RESEARCH_LINK_WIDGET_EDITORIAL_PATH, 'home-vehicle-showcase-v2'),
  })
);
